(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-hero-bkp"]) return;
  try {
    
  /* Back to top — only JS that stays at section level since the button
     lives outside the snippet boundaries (fixed-position FAB). */
  (function () {
    document.querySelectorAll('.ps-pdp').forEach(function (root) {
      var bttBtn = document.getElementById('ps-btt-' + root.id.replace('ps-pdp-', ''));
      if (!bttBtn) return;
      window.addEventListener('scroll', function () {
        bttBtn.classList.toggle('is-visible', window.scrollY > 400);
      }, { passive: true });
      bttBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-hero-v2"]) return;
  try {
    
  /* Back to top — only JS that stays at section level since the button
     lives outside the snippet boundaries (fixed-position FAB). */
  (function () {
    document.querySelectorAll('.ps-pdp').forEach(function (root) {
      var bttBtn = document.getElementById('ps-btt-' + root.id.replace('ps-pdp-', ''));
      if (!bttBtn) return;
      window.addEventListener('scroll', function () {
        bttBtn.classList.toggle('is-visible', window.scrollY > 400);
      }, { passive: true });
      bttBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pitch-announcement-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  var nav = document.querySelector('[data-ps-nav]');
  if (nav) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 40) nav.classList.add('is-scrolled');
      else nav.classList.remove('is-scrolled');
    }, { passive: true });
  }

  var drawer = document.querySelector('[data-ps-drawer]');
  var backdrop = document.querySelector('[data-ps-drawer-backdrop]');
  var openBtn = document.querySelector('[data-ps-drawer-open]');
  var closeBtn = document.querySelector('[data-ps-drawer-close]');
  if (!drawer || !backdrop || !openBtn) return;

  function openDrawer() {
    backdrop.hidden = false;
    // Force reflow so transition runs
    void backdrop.offsetWidth;
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('ps-annav-drawer-open');
    drawer.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('ps-annav-drawer-open');
    // Hide backdrop after transition ends
    setTimeout(function () {
      if (!backdrop.classList.contains('is-open')) backdrop.hidden = true;
    }, 300);
  }

  openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Close drawer if viewport grows past mobile breakpoint
  window.addEventListener('resize', function () {
    if (window.innerWidth > 960 && drawer.classList.contains('is-open')) closeDrawer();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pitch-pdp-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.ps-faq__head-btn').forEach(function(btn){
    btn.addEventListener('click', function(){ btn.parentElement.classList.toggle('is-open'); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pitch-pdp-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.ps-pdp').forEach(function(root){
    var thumbs = root.querySelectorAll('.ps-pdp__thumb');
    var slides = root.querySelectorAll('.ps-pdp__slide');
    var numEl = root.querySelector('[data-slide-num]');
    var current = 0;
    function go(i){
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function(s, idx){ s.classList.toggle('is-active', idx === current); });
      thumbs.forEach(function(t, idx){ t.classList.toggle('is-active', idx === current); });
      if (numEl) numEl.textContent = current + 1;
    }
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ go(parseInt(t.dataset.slide, 10) || 0); }); });
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function(){ go(current - 1); });
    if (next) next.addEventListener('click', function(){ go(current + 1); });

    var atcBtn = root.querySelector('[data-atc-btn]');
    var atcPrice = root.querySelector('[data-atc-price]');
    var baseLabel = atcBtn ? atcBtn.childNodes[0].nodeValue : '';
    root.querySelectorAll('.ps-pdp__bundle').forEach(function(opt){
      opt.addEventListener('click', function(e){
        if (e.target.closest('a')) return;
        root.querySelectorAll('.ps-pdp__bundle').forEach(function(o){ o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        var radio = opt.querySelector('.ps-pdp__bundle-radio-input');
        if (radio) radio.checked = true;
        if (atcPrice) atcPrice.textContent = ' — ' + (opt.dataset.bundlePrice || '');
      });
    });

    root.querySelectorAll('.ps-pdp__acc-head').forEach(function(head){
      head.addEventListener('click', function(){ head.parentElement.classList.toggle('is-open'); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pitch-pdp-loved"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.ps-trans').forEach(function(root){
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.speed, 10) || 5000;
    var pauseOnHover = root.dataset.pauseHover === 'true';

    var carouselSyncs = [];
    var compareSyncs = [];

    root.querySelectorAll('[data-carousel]').forEach(function(car){
      var sync = initCarousel(car, { autoplay: autoplay, speed: speed, pauseOnHover: pauseOnHover });
      if (sync) carouselSyncs.push({ car: car, sync: sync });

      car.querySelectorAll('[data-compare]').forEach(function(cmp){
        var cs = initCompare(cmp);
        if (cs) compareSyncs.push({ cmp: cmp, sync: cs });
      });
    });

    function syncPanel(panelEl){
      carouselSyncs.forEach(function(item){
        if (panelEl.contains(item.car)) item.sync();
      });
      compareSyncs.forEach(function(item){
        if (panelEl.contains(item.cmp)) item.sync();
      });
    }

    var tabs = root.querySelectorAll('.ps-trans__tab');
    var panels = root.querySelectorAll('.ps-trans__panel');
    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        var name = tab.dataset.tab;
        tabs.forEach(function(t){
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active);
        });
        var activePanel = null;
        panels.forEach(function(p){
          var active = p.dataset.panel === name;
          p.classList.toggle('is-active', active);
          if (active) activePanel = p;
        });
        if (activePanel) {
          requestAnimationFrame(function(){ syncPanel(activePanel); });
        }
      });
    });
  });

  function initCarousel(car, opts){
    var track = car.querySelector('[data-track]');
    var slides = track.children;
    var dotsWrap = car.querySelector('[data-dots]');
    var prev = car.querySelector('[data-prev]');
    var next = car.querySelector('[data-next]');
    var toggle = car.querySelector('[data-autoplay-toggle]');
    var index = 0, timer = null, isPlaying = opts.autoplay;

    if (!slides.length) return null;

    function perView(){
      var w = window.innerWidth;
      if (w <= 700) return 1;
      if (w <= 1024) return 2;
      return 3;
    }

    function totalPages(){
      return Math.max(1, slides.length - perView() + 1);
    }

    function buildDots(){
      dotsWrap.innerHTML = '';
      for (var i = 0; i < totalPages(); i++){
        var b = document.createElement('button');
        b.className = 'ps-trans__dot' + (i === index ? ' is-active' : '');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i+1));
        (function(idx){ b.addEventListener('click', function(){ go(idx); }); })(i);
        dotsWrap.appendChild(b);
      }
    }

    function update(){
      var slideW = slides[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      track.style.transform = 'translateX(' + (-(slideW + gap) * index) + 'px)';
      Array.prototype.forEach.call(dotsWrap.children, function(d, i){
        d.classList.toggle('is-active', i === index);
      });
    }

    function go(i){
      var max = totalPages() - 1;
      index = i < 0 ? max : i > max ? 0 : i;
      update();
    }

    function play(){
      if (timer) clearInterval(timer);
      timer = setInterval(function(){ go(index + 1); }, opts.speed);
    }
    function stop(){ if (timer) { clearInterval(timer); timer = null; } }

    prev.addEventListener('click', function(){ go(index - 1); if (isPlaying) play(); });
    next.addEventListener('click', function(){ go(index + 1); if (isPlaying) play(); });

    if (opts.pauseOnHover){
      car.addEventListener('mouseenter', stop);
      car.addEventListener('mouseleave', function(){ if (isPlaying) play(); });
    }

    if (toggle){
      toggle.addEventListener('click', function(){
        isPlaying = !isPlaying;
        toggle.setAttribute('aria-pressed', isPlaying);
        toggle.querySelector('[data-icon-pause]').hidden = !isPlaying;
        toggle.querySelector('[data-icon-play]').hidden = isPlaying;
        if (isPlaying) play(); else stop();
      });
    }

    window.addEventListener('resize', function(){
      buildDots();
      if (index >= totalPages()) index = totalPages() - 1;
      update();
    });

    buildDots();
    update();
    if (opts.autoplay) play();

    return function(){
      buildDots();
      if (index >= totalPages()) index = totalPages() - 1;
      update();
    };
  }

  function initCompare(el){
    var clip = el.querySelector('[data-clip]');
    var handle = el.querySelector('[data-handle]');
    var beforeImg = el.querySelector('.ps-trans__compare-img--before');
    var dragging = false;
    var currentPct = 50;

    function sizeBefore(){
      if (!beforeImg) return;
      var rect = el.getBoundingClientRect();
      if (rect.width === 0) return;
      beforeImg.style.width = rect.width + 'px';
      beforeImg.style.height = rect.height + 'px';
    }

    function setPos(pct){
      pct = Math.max(0, Math.min(100, pct));
      currentPct = pct;
      clip.style.width = pct + '%';
      handle.style.left = pct + '%';
    }

    function fromEvent(e){
      var rect = el.getBoundingClientRect();
      if (rect.width === 0) return;
      var pt = e.touches ? e.touches[0] : e;
      var x = pt.clientX - rect.left;
      setPos((x / rect.width) * 100);
    }

    function start(e){
      if (e.type === 'mousedown' && e.button !== 0) return;
      if (el.getBoundingClientRect().width === 0) return;
      dragging = true;
      e.preventDefault();
    }
    function move(e){ if (dragging) fromEvent(e); }
    function end(){ dragging = false; }

    handle.addEventListener('mousedown', start);
    handle.addEventListener('touchstart', start, { passive: false });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', end);
    window.addEventListener('touchend', end);
    window.addEventListener('resize', sizeBefore);

    if (beforeImg && !beforeImg.complete) {
      beforeImg.addEventListener('load', sizeBefore);
    }
    sizeBefore();
    setPos(50);

    return function(){
      sizeBefore();
      setPos(currentPct);
    };
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pitch-pdp-special"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-ps-special]').forEach(function(root){
    var car = root.querySelector('[data-carousel]');
    if (!car) return;

    var track = car.querySelector('[data-track]');
    var slides = track ? track.children : [];
    var dotsWrap = car.querySelector('[data-dots]');
    var prev = car.querySelector('[data-prev]');
    var next = car.querySelector('[data-next]');
    var index = 0;
    var touchStartX = 0;
    var touchEndX = 0;

    if (!slides.length) return;

    function isMobile(){
      return window.innerWidth <= 767;
    }

    function totalSlides(){
      return slides.length;
    }

    function buildDots(){
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (!isMobile()) return;
      for (var i = 0; i < totalSlides(); i++){
        var b = document.createElement('button');
        b.className = 'ps-special__dot' + (i === index ? ' is-active' : '');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i+1));
        (function(idx){ b.addEventListener('click', function(){ go(idx); }); })(i);
        dotsWrap.appendChild(b);
      }
    }

    function update(){
      if (!isMobile()){
        track.style.transform = '';
        return;
      }
      var slideW = slides[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      track.style.transform = 'translateX(' + (-(slideW + gap) * index) + 'px)';
      if (dotsWrap){
        Array.prototype.forEach.call(dotsWrap.children, function(d, i){
          d.classList.toggle('is-active', i === index);
        });
      }
    }

    function go(i){
      var max = totalSlides() - 1;
      index = i < 0 ? max : i > max ? 0 : i;
      update();
    }

    if (prev) prev.addEventListener('click', function(){ go(index - 1); });
    if (next) next.addEventListener('click', function(){ go(index + 1); });

    // Touch swipe support
    track.addEventListener('touchstart', function(e){
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', function(e){
      touchEndX = e.changedTouches[0].clientX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50){
        if (diff > 0) go(index + 1);
        else go(index - 1);
      }
    });

    window.addEventListener('resize', function(){
      if (!isMobile()) index = 0;
      buildDots();
      update();
    });

    buildDots();
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pitch-results"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.ps-results').forEach(function(root){
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.speed, 10) || 5000;
    var pauseOnHover = root.dataset.pauseHover === 'true';
    var carouselMode = root.dataset.carouselMode === 'true';

    root.querySelectorAll('[data-compare]').forEach(initCompare);

    if (carouselMode) {
      var car = root.querySelector('[data-carousel]');
      if (car) initCarousel(car, { autoplay: autoplay, speed: speed, pauseOnHover: pauseOnHover });
    }
  });

  function initCarousel(car, opts){
    var track = car.querySelector('[data-track]');
    var slides = track.children;
    var dotsWrap = car.querySelector('[data-dots]');
    var prev = car.querySelector('[data-prev]');
    var next = car.querySelector('[data-next]');
    var toggle = car.querySelector('[data-autoplay-toggle]');
    var index = 0, timer = null, isPlaying = opts.autoplay;

    if (!slides.length) return;

    function perView(){
      return window.innerWidth <= 960 ? 1 : 2;
    }

    function totalPages(){
      return Math.max(1, slides.length - perView() + 1);
    }

    function buildDots(){
      dotsWrap.innerHTML = '';
      for (var i = 0; i < totalPages(); i++){
        var b = document.createElement('button');
        b.className = 'ps-results__dot' + (i === index ? ' is-active' : '');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i+1));
        (function(idx){ b.addEventListener('click', function(){ go(idx); restart(); }); })(i);
        dotsWrap.appendChild(b);
      }
    }

    function update(){
      var slideW = slides[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      track.style.transform = 'translateX(' + (-(slideW + gap) * index) + 'px)';
      Array.prototype.forEach.call(dotsWrap.children, function(d, i){
        d.classList.toggle('is-active', i === index);
      });
    }

    function go(i){
      var max = totalPages() - 1;
      index = i < 0 ? max : i > max ? 0 : i;
      update();
    }

    function play(){
      if (timer) clearInterval(timer);
      timer = setInterval(function(){ go(index + 1); }, opts.speed);
    }
    function stop(){ if (timer) { clearInterval(timer); timer = null; } }
    function restart(){ if (isPlaying) play(); }

    prev.addEventListener('click', function(){ go(index - 1); restart(); });
    next.addEventListener('click', function(){ go(index + 1); restart(); });

    if (opts.pauseOnHover){
      car.addEventListener('mouseenter', stop);
      car.addEventListener('mouseleave', function(){ if (isPlaying) play(); });
    }

    if (toggle){
      toggle.addEventListener('click', function(){
        isPlaying = !isPlaying;
        toggle.setAttribute('aria-pressed', isPlaying);
        toggle.querySelector('[data-icon-pause]').hidden = !isPlaying;
        toggle.querySelector('[data-icon-play]').hidden = isPlaying;
        if (isPlaying) play(); else stop();
      });
    }

    window.addEventListener('resize', function(){
      buildDots();
      if (index >= totalPages()) index = totalPages() - 1;
      update();
    });

    buildDots();
    update();
    if (opts.autoplay) play();
  }

  function initCompare(el){
    var clip = el.querySelector('[data-clip]');
    var handle = el.querySelector('[data-handle]');
    var beforeImg = el.querySelector('.ps-results__compare-img--before');
    var dragging = false;

    function sizeBefore(){
      if (!beforeImg) return;
      var rect = el.getBoundingClientRect();
      beforeImg.style.width = rect.width + 'px';
      beforeImg.style.height = rect.height + 'px';
    }

    function setPos(pct){
      pct = Math.max(0, Math.min(100, pct));
      clip.style.width = pct + '%';
      handle.style.left = pct + '%';
    }

    function fromEvent(e){
      var rect = el.getBoundingClientRect();
      var pt = e.touches ? e.touches[0] : e;
      var x = pt.clientX - rect.left;
      setPos((x / rect.width) * 100);
    }

    function start(e){
      if (e.type === 'mousedown' && e.button !== 0) return;
      dragging = true;
      e.preventDefault();
    }
    function move(e){ if (dragging) fromEvent(e); }
    function end(){ dragging = false; }

    handle.addEventListener('mousedown', start);
    handle.addEventListener('touchstart', start, { passive: false });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', end);
    window.addEventListener('touchend', end);
    window.addEventListener('resize', sizeBefore);

    if (beforeImg && !beforeImg.complete) {
      beforeImg.addEventListener('load', sizeBefore);
    }
    sizeBefore();
    setPos(50);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pitch-tiktok-ugc"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ps-tiktok]').forEach(function (rail) {
    var track = rail.querySelector('[data-ps-tiktok-track]');
    if (!track) return;
    var prev = rail.querySelector('[data-ps-tiktok-prev]');
    var next = rail.querySelector('[data-ps-tiktok-next]');
    var originals = Array.prototype.slice.call(track.querySelectorAll('.ps-tiktok__card'));
    if (!originals.length) return;

    // Clone cards on both sides for seamless infinite loop
    originals.forEach(function (card) {
      var c = card.cloneNode(true);
      c.setAttribute('data-clone', 'end');
      track.appendChild(c);
    });
    originals.slice().reverse().forEach(function (card) {
      var c = card.cloneNode(true);
      c.setAttribute('data-clone', 'start');
      track.insertBefore(c, track.firstChild);
    });

    var allCards = Array.prototype.slice.call(track.querySelectorAll('.ps-tiktok__card'));
    var originalCount = originals.length;

    function step() {
      var card = allCards[0];
      if (!card) return 300;
      var style = getComputedStyle(track);
      var gap = parseInt(style.columnGap || style.gap || 20, 10) || 20;
      return card.getBoundingClientRect().width + gap;
    }

    function originalsWidth() {
      return step() * originalCount;
    }

    // Position at the first "real" (non-clone) card
    function setInitial() {
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = originalsWidth();
      track.style.scrollBehavior = 'smooth';
    }
    setInitial();
    window.addEventListener('resize', setInitial);

    // Seamless loop: snap back by one full set when crossing edges
    var isAdjusting = false;
    track.addEventListener('scroll', function () {
      if (isAdjusting) return;
      var setW = originalsWidth();
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= setW * 2 - 1 || track.scrollLeft >= maxScroll - 1) {
        isAdjusting = true;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = track.scrollLeft - setW;
        track.style.scrollBehavior = 'smooth';
        requestAnimationFrame(function () { isAdjusting = false; });
      } else if (track.scrollLeft <= 0) {
        isAdjusting = true;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = track.scrollLeft + setW;
        track.style.scrollBehavior = 'smooth';
        requestAnimationFrame(function () { isAdjusting = false; });
      }
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    allCards.forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;
      video.addEventListener('play',  function () { card.classList.add('is-playing'); });
      video.addEventListener('pause', function () { card.classList.remove('is-playing'); });
      video.addEventListener('ended', function () { card.classList.remove('is-playing'); video.currentTime = 0; });
      card.addEventListener('click', function (e) {
        e.preventDefault();
        if (video.paused) {
          allCards.forEach(function (c) {
            var v = c.querySelector('video');
            if (v && v !== video) v.pause();
          });
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          video.pause();
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-section"] && !Shopify.designMode) return;
  try {
    
  /* Back to top — only JS that stays at section level since the button
     lives outside the snippet boundaries (fixed-position FAB). */
  (function () {
    document.querySelectorAll('.ps-pdp').forEach(function (root) {
      var bttBtn = document.getElementById('ps-btt-' + root.id.replace('ps-pdp-', ''));
      if (!bttBtn) return;
      window.addEventListener('scroll', function () {
        bttBtn.classList.toggle('is-visible', window.scrollY > 400);
      }, { passive: true });
      bttBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
